import styled from 'styled-components';

import {
  SkeletonBodyCopy as DefaultSkeletonBodyCopy,
  SkeletonHeadline as DefaultSkeletonHeadline,
  SkeletonProfileImage as DefaultSkeletonProfileImage,
} from '@xing-com/skeleton';
import { spaceS, spaceL, spaceXXL, space3XL } from '@xing-com/tokens';

import { JOB_ACTIVITY_IMAGE_SIZE } from '../../constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${space3XL} ${spaceXXL};
`;

export const Hero = styled(DefaultSkeletonHeadline)`
  margin-bottom: ${spaceL};
`;

export const BodyCopy = styled(DefaultSkeletonBodyCopy)`
  margin: 0;
`;

export const SavedJobs = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceL};
  margin-top: ${spaceXXL};
`;

export const SectionHeadline = styled(DefaultSkeletonHeadline)`
  margin: 0;
`;

export const SavedJob = styled.div`
  display: flex;
  min-height: ${JOB_ACTIVITY_IMAGE_SIZE};
`;

export const JobImage = styled(DefaultSkeletonProfileImage)`
  flex-shrink: 0;
  max-width: ${JOB_ACTIVITY_IMAGE_SIZE};
  max-height: ${JOB_ACTIVITY_IMAGE_SIZE};
`;

export const JobText = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  margin-left: ${spaceL};
`;

export const JobHeadline = styled(DefaultSkeletonHeadline)`
  margin: 0 0 ${spaceS};
`;

export const JobBodyCopy = styled(DefaultSkeletonBodyCopy)`
  margin: 0;
`;
